export const HEADERS = ["Код", "Диагноз", ""];

export const TISSUE_OPTIONS = [
    {value: 'colon',  label: 'Толстая кишка'},
    {value: 'lung',   label: 'Легкое'},
    {value: 'mc', label: 'Молочная железа'},
];

const SVS_EXTENSION = ".svs";

// К загрузке принимаются только файлы слайдов
const ACCEPTED_FILE_TYPES = [SVS_EXTENSION];

// Текст статуса для файлов, не являющихся SVS.
// Дублируется на сервере: backend/apps/slide/lib/svs_validation.py
const FILE_EXTENSION_ERROR_MESSAGE =
    "Ошибка - расширение файла не соответствует";

const FILE_EXISTS_ERROR_MESSAGE = "Файл уже существует";

const UPLOADING_STATUS = {
    Initialization: "initialization",
    Loading: "loading",
    Success: "success",
    Processing: "processing",
    UploadingError: "uploadingError",
};

const UPLOADING_STATUS_MESSAGE = {
    [UPLOADING_STATUS.Initialization]: {
        message:
            'Добавьте файлы для загрузки с помощью кнопки "Выбрать файлы" или перетащите мышкой в область "Выбранные файлы"',
        color: "text.primary",
    },
    [UPLOADING_STATUS.Loading]: {
        message: "Выполняется загрузка...",
        color: "text.primary",
    },
    [UPLOADING_STATUS.Success]: {
        message: "Загрузка успешно завершена!",
        color: "success.main",
    },
    [UPLOADING_STATUS.Processing]: {
        message: "Файлы обрабатываются, не закрывайте страницу!",
        color: "error.main",
    },
    [UPLOADING_STATUS.UploadingError]: {
        message: "Загрузка завершилась с ошибкой!",
        color: "error.main",
    },
};

const DEFAULT_UPLOAD_QUEUE = {
    completed: [],
    loading: [],
    waiting: [],
};

export {
    SVS_EXTENSION,
    ACCEPTED_FILE_TYPES,
    FILE_EXTENSION_ERROR_MESSAGE,
    FILE_EXISTS_ERROR_MESSAGE,
    UPLOADING_STATUS,
    UPLOADING_STATUS_MESSAGE,
    DEFAULT_UPLOAD_QUEUE,
};
